/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { ReactNode } from 'react';
import { IconSolidCheckmark } from 'src/components/Icons';
import styles from './styles.module.scss';

interface SelectableCardProps {
    disabled?: boolean;
    selected?: boolean;
    onSelect?: React.MouseEventHandler<HTMLButtonElement>;
    containerClassname?: string;
    children: ReactNode;
    withInput?: ReactNode;
}

function SelectableCard({
    onSelect,
    selected,
    disabled,
    containerClassname,
    children,
    withInput,
}: SelectableCardProps) {
    const buttonContainerClassname = selected
        ? styles.containerSelected
        : styles.containerUnselected;
    return (
        <div className={buttonContainerClassname}>
            <button
                type="button"
                onClick={onSelect}
                disabled={disabled}
                role="button"
                className={styles.cardButton}
            >
                <span className={styles.checkmarkContainer}>
                    <IconSolidCheckmark
                        width={24}
                        height={24}
                        bgFillColor="fillTransparent"
                    />
                </span>
                <div
                    className={containerClassname}
                    style={withInput ? { paddingBottom: '0px' } : {}}
                >
                    {children}
                </div>
            </button>
            {withInput && <div className={styles.cardInput}>{withInput}</div>}
        </div>
    );
}

export default SelectableCard;
